export default __webpack_public_path__ + "static/logo-1-321f296b2ca2b05b0d304862edb938fd.webp";